import React from 'react';
import { pure } from 'recompose';
import UsergroupItem from '../../containers/UsergroupItem';
import './Usergroup.css';

const Usergroup = props => {
  const { group, filteredUsers } = props;
  const { groupname } = group;

  const renderUsers = () => {
    const { filter, selectedGroup, selectedUser, onSelectUser } = props;
    const { groupId } = group;
    return filteredUsers.map(user => {
      const selected = selectedGroup === group && selectedUser === user;
      return (
        <UsergroupItem
          key={groupId + user.id}
          user={user}
          filter={filter}
          selected={selected}
          onClick={() => onSelectUser && (selected
            ? onSelectUser()
            : onSelectUser(user, group))
          }
        />
      );
    });
  };

  if (filteredUsers.length === 0) {
    return null;
  }

  return (
    <div className="Usergroup">
      <div className="header">
        <div className="title">{groupname}</div>
      </div>
      <div className="content">
        {renderUsers(props, filteredUsers)}
      </div>
    </div>
  );
};

export default pure(Usergroup);



// WEBPACK FOOTER //
// ./src/components/Usergroup/Usergroup.jsx